import { render } from "./Donor.vue?vue&type=template&id=7ed9b168"
import script from "./Donor.vue?vue&type=script&lang=js"
export * from "./Donor.vue?vue&type=script&lang=js"
script.render = render

export default script